const BASE = {
  sage:   '#2D6A4F',
  sageLt: '#40916C',
  mint:   '#95D5B2',
  mintLt: '#D8F3DC',
  cream:  '#F8F4EF',
  terra:  '#C9726A',
  carbon: '#1C2B22',
  gray:   '#6B7280',
};

// Paletas placeholder — pendientes de validación de diseño (ver Fase 3 del plan).
// young_female / pre_surgery quedan sin definir a propósito: caen en BASE.
const PERSONA_THEMES = {
  menopause:  { sage: '#8A5A83', sageLt: '#A97AA1', mint: '#E4C7DE', mintLt: '#F3E5F0', cream: '#FAF5F8' },
  young_male: { sage: '#2B5F8A', sageLt: '#3D7DB0', mint: '#A9CBE8', mintLt: '#DCEBF7', cream: '#F5F9FC' },
};

let current = { ...BASE };

export function setPersonaTheme(persona) {
  current = { ...BASE, ...(PERSONA_THEMES[persona] || {}) };
}

// Getters, no valores estáticos: cada import { C } sigue funcionando igual en
// todos los sitios existentes (C.sage, C.mint, ...), pero ahora lee el valor
// vigente en cada render en vez de un objeto congelado en el momento del import.
export const C = {
  get sage()   { return current.sage; },
  get sageLt() { return current.sageLt; },
  get mint()   { return current.mint; },
  get mintLt() { return current.mintLt; },
  get cream()  { return current.cream; },
  get terra()  { return current.terra; },
  get carbon() { return current.carbon; },
  get gray()   { return current.gray; },
};
